export default "__VITE_ASSET__d5e14593__"